import { colorToCss } from "../../color/color"
import { isString } from "../../utils/utils"

export interface IRangeValueColor {
    MinValue: number
    MaxValue: number
    Colour: number[]
    Index?: number
    Label?: string
}


export function getColors(key: string) {
    return standard[key]
}

export function getSoilColors(property: keyof typeof standard) {

    const from = standard[property]
    if (!from) return undefined

    return from.map(c => ({ Value: c.MinValue, Colour: c.Colour, Index: c.Index, Label: c.Label }))

}


export function getGaugeStyle(value: number, key: string): {}
export function getGaugeStyle(value: number, range: IRangeValueColor[]): {}
export function getGaugeStyle(value: number, arg: string | IRangeValueColor[]): {} {

    const values = isString(arg) ? standard[arg] : arg
    if (!values) return null

    const match = values.find(v => (v.MinValue <= value) && (v.MaxValue > value))
    if (!match) return null

    let rotate = match.Index

    if (rotate <= 0) {
        rotate = 0.1
    } else if (rotate > 5) {
        rotate = 5
    }

    return {
        "transform": `rotate(${(rotate / 10)}turn)`,
        "background-color": (match ? colorToCss(match.Colour) : "rgb(0,0,0)")
    }

}

export function getValueIndex(value: number, key: string) {

    var values = standard[key]
    if (!values) return null

    var match = values.find(v => (v.MinValue <= value) && (v.MaxValue > value))
    if (!match) return null

    return match.Index
}

export const nitrogen = [
    { MinValue: 0, MaxValue: 60, Colour: [108, 182, 255], Index: 0 },
    { MinValue: 60, MaxValue: 80, Colour: [90, 159, 255], Index: 1 },
    { MinValue: 80, MaxValue: 100, Colour: [72, 133, 255], Index: 2 },
    { MinValue: 100, MaxValue: 120, Colour: [54, 104, 255], Index: 3 },
    { MinValue: 120, MaxValue: 160, Colour: [35, 72, 255], Index: 4 },
    { MinValue: 160, MaxValue: 240, Colour: [17, 37, 255], Index: 5 },
    { MinValue: 240, MaxValue: 1000, Colour: [0, 0, 255], Index: 6 },
]

export const standard: { [key: string]: IRangeValueColor[] } = {

    // N / Nitrogen / SNS
    // Note: temporary workaround to support viewers for nitrogen analysis
    // At some point, we should merge those colour definitions with those found in setup.ts,
    // and improve the soil analysis layer viewer so as to be able to use the index found
    // in the set of colours it relies on
    N: nitrogen,
    Nitrogen: nitrogen,
    SNS: nitrogen,

    // P2O5
    P2O5: [
        { MinValue: 0, MaxValue: 1, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 1, MaxValue: 2, Colour: [255, 0, 0], Index: 0.1 },
        { MinValue: 2, MaxValue: 3, Colour: [255, 0, 0], Index: 0.2 },
        { MinValue: 3, MaxValue: 4, Colour: [255, 0, 0], Index: 0.3 },
        { MinValue: 4, MaxValue: 5, Colour: [255, 0, 0], Index: 0.4 },
        { MinValue: 5, MaxValue: 6, Colour: [192, 0, 0], Index: 0.5 },
        { MinValue: 6, MaxValue: 7, Colour: [192, 0, 0], Index: 0.6 },
        { MinValue: 7, MaxValue: 8, Colour: [192, 0, 0], Index: 0.7 },
        { MinValue: 8, MaxValue: 9, Colour: [192, 0, 0], Index: 0.8 },
        { MinValue: 9, MaxValue: 10, Colour: [192, 0, 0], Index: 0.9 },
        { MinValue: 10, MaxValue: 11, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 11, MaxValue: 12, Colour: [255, 135, 0], Index: 1.2 },
        { MinValue: 12, MaxValue: 13, Colour: [255, 135, 0], Index: 1.4 },
        { MinValue: 13, MaxValue: 14, Colour: [255, 255, 0], Index: 1.6 },
        { MinValue: 14, MaxValue: 15, Colour: [255, 255, 0], Index: 1.8 },
        { MinValue: 15, MaxValue: 16, Colour: [255, 255, 0], Index: 1.9 },
        { MinValue: 16, MaxValue: 17, Colour: [63, 242, 0], Index: 2 },
        { MinValue: 17, MaxValue: 18, Colour: [63, 242, 0], Index: 2.1 },
        { MinValue: 18, MaxValue: 19, Colour: [63, 242, 0], Index: 2.2 },
        { MinValue: 19, MaxValue: 20, Colour: [63, 242, 0], Index: 2.3 },
        { MinValue: 20, MaxValue: 21, Colour: [63, 242, 0], Index: 2.4 },
        { MinValue: 21, MaxValue: 22, Colour: [37, 142, 0], Index: 2.5 },
        { MinValue: 22, MaxValue: 23, Colour: [37, 142, 0], Index: 2.6 },
        { MinValue: 23, MaxValue: 24, Colour: [37, 142, 0], Index: 2.7 },
        { MinValue: 24, MaxValue: 25, Colour: [37, 142, 0], Index: 2.8 },
        { MinValue: 25, MaxValue: 26, Colour: [37, 142, 0], Index: 2.9 },
        { MinValue: 26, MaxValue: 28, Colour: [72, 185, 185], Index: 3 },
        { MinValue: 28, MaxValue: 30, Colour: [72, 185, 185], Index: 3.1 },
        { MinValue: 30, MaxValue: 32, Colour: [72, 185, 185], Index: 3.2 },
        { MinValue: 32, MaxValue: 34, Colour: [72, 185, 185], Index: 3.3 },
        { MinValue: 34, MaxValue: 37, Colour: [72, 185, 185], Index: 3.4 },
        { MinValue: 37, MaxValue: 39, Colour: [17, 91, 239], Index: 3.5 },
        { MinValue: 39, MaxValue: 41, Colour: [17, 91, 239], Index: 3.6 },
        { MinValue: 41, MaxValue: 43, Colour: [17, 91, 239], Index: 3.7 },
        { MinValue: 43, MaxValue: 45, Colour: [17, 91, 239], Index: 3.8 },
        { MinValue: 45, MaxValue: 46, Colour: [17, 91, 239], Index: 3.9 },
        { MinValue: 46, MaxValue: 49, Colour: [234, 0, 206], Index: 4 },
        { MinValue: 49, MaxValue: 51, Colour: [234, 0, 206], Index: 4.1 },
        { MinValue: 51, MaxValue: 54, Colour: [234, 0, 206], Index: 4.2 },
        { MinValue: 54, MaxValue: 57, Colour: [234, 0, 206], Index: 4.3 },
        { MinValue: 57, MaxValue: 60, Colour: [234, 0, 206], Index: 4.4 },
        { MinValue: 60, MaxValue: 62, Colour: [139, 0, 139], Index: 4.5 },
        { MinValue: 62, MaxValue: 65, Colour: [139, 0, 139], Index: 4.6 },
        { MinValue: 65, MaxValue: 68, Colour: [139, 0, 139], Index: 4.7 },
        { MinValue: 68, MaxValue: 70, Colour: [139, 0, 139], Index: 4.8 },
        { MinValue: 70, MaxValue: 71, Colour: [139, 0, 139], Index: 4.9 },
        { MinValue: 71, MaxValue: 1000, Colour: [139, 0, 139], Index: 5 }
    ],

    // K2O
    K2O: [
        { MinValue: 0, MaxValue: 7, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 7, MaxValue: 14, Colour: [255, 0, 0], Index: 0.1 },
        { MinValue: 14, MaxValue: 20, Colour: [255, 0, 0], Index: 0.2 },
        { MinValue: 20, MaxValue: 27, Colour: [255, 0, 0], Index: 0.3 },
        { MinValue: 27, MaxValue: 34, Colour: [255, 0, 0], Index: 0.4 },
        { MinValue: 34, MaxValue: 40, Colour: [192, 0, 0], Index: 0.5 },
        { MinValue: 40, MaxValue: 47, Colour: [192, 0, 0], Index: 0.6 },
        { MinValue: 47, MaxValue: 54, Colour: [192, 0, 0], Index: 0.7 },
        { MinValue: 54, MaxValue: 60, Colour: [192, 0, 0], Index: 0.8 },
        { MinValue: 60, MaxValue: 61, Colour: [192, 0, 0], Index: 0.9 },
        { MinValue: 61, MaxValue: 68, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 68, MaxValue: 74, Colour: [255, 135, 0], Index: 1.1 },
        { MinValue: 74, MaxValue: 81, Colour: [255, 135, 0], Index: 1.2 },
        { MinValue: 81, MaxValue: 87, Colour: [255, 135, 0], Index: 1.3 },
        { MinValue: 87, MaxValue: 94, Colour: [255, 135, 0], Index: 1.4 },
        { MinValue: 94, MaxValue: 101, Colour: [255, 255, 0], Index: 1.5 },
        { MinValue: 101, MaxValue: 107, Colour: [255, 255, 0], Index: 1.6 },
        { MinValue: 107, MaxValue: 114, Colour: [255, 255, 0], Index: 1.7 },
        { MinValue: 114, MaxValue: 120, Colour: [255, 255, 0], Index: 1.8 },
        { MinValue: 120, MaxValue: 121, Colour: [255, 255, 0], Index: 1.9 },
        { MinValue: 121, MaxValue: 134, Colour: [63, 242, 0], Index: 2 },
        { MinValue: 134, MaxValue: 147, Colour: [63, 242, 0], Index: 2.1 },
        { MinValue: 147, MaxValue: 161, Colour: [63, 242, 0], Index: 2.2 },
        { MinValue: 161, MaxValue: 174, Colour: [63, 242, 0], Index: 2.3 },
        { MinValue: 174, MaxValue: 187, Colour: [63, 242, 0], Index: 2.4 },
        { MinValue: 187, MaxValue: 200, Colour: [37, 142, 0], Index: 2.5 },
        { MinValue: 200, MaxValue: 213, Colour: [37, 142, 0], Index: 2.6 },
        { MinValue: 213, MaxValue: 227, Colour: [37, 142, 0], Index: 2.7 },
        { MinValue: 227, MaxValue: 240, Colour: [37, 142, 0], Index: 2.8 },
        { MinValue: 240, MaxValue: 241, Colour: [37, 142, 0], Index: 2.9 },
        { MinValue: 241, MaxValue: 259, Colour: [72, 185, 185], Index: 3 },
        { MinValue: 259, MaxValue: 276, Colour: [72, 185, 185], Index: 3.1 },
        { MinValue: 276, MaxValue: 294, Colour: [72, 185, 185], Index: 3.2 },
        { MinValue: 294, MaxValue: 312, Colour: [72, 185, 185], Index: 3.3 },
        { MinValue: 312, MaxValue: 330, Colour: [72, 185, 185], Index: 3.4 },
        { MinValue: 330, MaxValue: 347, Colour: [17, 91, 239], Index: 3.5 },
        { MinValue: 347, MaxValue: 365, Colour: [17, 91, 239], Index: 3.6 },
        { MinValue: 365, MaxValue: 383, Colour: [17, 91, 239], Index: 3.7 },
        { MinValue: 383, MaxValue: 400, Colour: [17, 91, 239], Index: 3.8 },
        { MinValue: 400, MaxValue: 401, Colour: [17, 91, 239], Index: 3.9 },
        { MinValue: 401, MaxValue: 423, Colour: [234, 0, 206], Index: 4 },
        { MinValue: 423, MaxValue: 445, Colour: [234, 0, 206], Index: 4.1 },
        { MinValue: 445, MaxValue: 467, Colour: [234, 0, 206], Index: 4.2 },
        { MinValue: 467, MaxValue: 489, Colour: [234, 0, 206], Index: 4.3 },
        { MinValue: 489, MaxValue: 512, Colour: [234, 0, 206], Index: 4.4 },
        { MinValue: 512, MaxValue: 601, Colour: [139, 0, 139], Index: 4.5 },
        { MinValue: 534, MaxValue: 601, Colour: [139, 0, 139], Index: 4.6 },
        { MinValue: 556, MaxValue: 601, Colour: [139, 0, 139], Index: 4.7 },
        { MinValue: 578, MaxValue: 601, Colour: [139, 0, 139], Index: 4.8 },
        { MinValue: 600, MaxValue: 601, Colour: [139, 0, 139], Index: 4.9 },
        { MinValue: 601, MaxValue: 3000, Colour: [139, 0, 139], Index: 5 }
    ],

    // MgO
    MgO: [
        { MinValue: 0, MaxValue: 3, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 3, MaxValue: 6, Colour: [255, 0, 0], Index: 0.1 },
        { MinValue: 6, MaxValue: 8, Colour: [255, 0, 0], Index: 0.2 },
        { MinValue: 8, MaxValue: 11.1, Colour: [255, 0, 0], Index: 0.3 },
        { MinValue: 11.1, MaxValue: 13.85, Colour: [255, 0, 0], Index: 0.4 },
        { MinValue: 13.85, MaxValue: 16.6, Colour: [192, 0, 0], Index: 0.5 },
        { MinValue: 16.6, MaxValue: 19.35, Colour: [192, 0, 0], Index: 0.6 },
        { MinValue: 19.35, MaxValue: 22.1, Colour: [192, 0, 0], Index: 0.7 },
        { MinValue: 22.1, MaxValue: 25, Colour: [192, 0, 0], Index: 0.8 },
        { MinValue: 25, MaxValue: 26, Colour: [192, 0, 0], Index: 0.9 },
        { MinValue: 26, MaxValue: 28.66, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 28.66, MaxValue: 31.32, Colour: [255, 135, 0], Index: 1.1 },
        { MinValue: 31.32, MaxValue: 33.98, Colour: [255, 135, 0], Index: 1.2 },
        { MinValue: 33.98, MaxValue: 36.64, Colour: [255, 135, 0], Index: 1.3 },
        { MinValue: 36.64, MaxValue: 39.3, Colour: [255, 135, 0], Index: 1.4 },
        { MinValue: 39.3, MaxValue: 41.96, Colour: [255, 255, 0], Index: 1.5 },
        { MinValue: 41.96, MaxValue: 44.62, Colour: [255, 255, 0], Index: 1.6 },
        { MinValue: 44.62, MaxValue: 47.28, Colour: [255, 255, 0], Index: 1.7 },
        { MinValue: 47.28, MaxValue: 50, Colour: [255, 255, 0], Index: 1.8 },
        { MinValue: 50, MaxValue: 51, Colour: [255, 255, 0], Index: 1.9 },
        { MinValue: 51, MaxValue: 56.45, Colour: [63, 242, 0], Index: 2 },
        { MinValue: 56.45, MaxValue: 61.9, Colour: [63, 242, 0], Index: 2.1 },
        { MinValue: 61.9, MaxValue: 67.35, Colour: [63, 242, 0], Index: 2.2 },
        { MinValue: 67.35, MaxValue: 72.8, Colour: [63, 242, 0], Index: 2.3 },
        { MinValue: 72.8, MaxValue: 78.25, Colour: [63, 242, 0], Index: 2.4 },
        { MinValue: 78.25, MaxValue: 83.7, Colour: [37, 142, 0], Index: 2.5 },
        { MinValue: 83.7, MaxValue: 89.15, Colour: [37, 142, 0], Index: 2.6 },
        { MinValue: 89.15, MaxValue: 94.6, Colour: [37, 142, 0], Index: 2.7 },
        { MinValue: 94.6, MaxValue: 100, Colour: [37, 142, 0], Index: 2.8 },
        { MinValue: 100, MaxValue: 101, Colour: [37, 142, 0], Index: 2.9 },
        { MinValue: 101, MaxValue: 109.2, Colour: [72, 185, 185], Index: 3 },
        { MinValue: 109.2, MaxValue: 117.4, Colour: [72, 185, 185], Index: 3.1 },
        { MinValue: 117.4, MaxValue: 125.6, Colour: [72, 185, 185], Index: 3.2 },
        { MinValue: 125.6, MaxValue: 133.8, Colour: [72, 185, 185], Index: 3.3 },
        { MinValue: 133.8, MaxValue: 142, Colour: [72, 185, 185], Index: 3.4 },
        { MinValue: 142, MaxValue: 150.2, Colour: [17, 91, 239], Index: 3.5 },
        { MinValue: 150.2, MaxValue: 158.4, Colour: [17, 91, 239], Index: 3.6 },
        { MinValue: 158.4, MaxValue: 166.6, Colour: [17, 91, 239], Index: 3.7 },
        { MinValue: 166.6, MaxValue: 175, Colour: [17, 91, 239], Index: 3.8 },
        { MinValue: 175, MaxValue: 176, Colour: [17, 91, 239], Index: 3.9 },
        { MinValue: 176, MaxValue: 184.2, Colour: [234, 0, 206], Index: 4 },
        { MinValue: 184.2, MaxValue: 192.4, Colour: [234, 0, 206], Index: 4.1 },
        { MinValue: 192.4, MaxValue: 200.6, Colour: [234, 0, 206], Index: 4.2 },
        { MinValue: 200.6, MaxValue: 208.8, Colour: [234, 0, 206], Index: 4.3 },
        { MinValue: 208.8, MaxValue: 217, Colour: [234, 0, 206], Index: 4.4 },
        { MinValue: 217, MaxValue: 225.2, Colour: [139, 0, 139], Index: 4.5 },
        { MinValue: 225.2, MaxValue: 233.4, Colour: [139, 0, 139], Index: 4.6 },
        { MinValue: 233.4, MaxValue: 241.6, Colour: [139, 0, 139], Index: 4.7 },
        { MinValue: 241.6, MaxValue: 250, Colour: [139, 0, 139], Index: 4.8 },
        { MinValue: 250, MaxValue: 251, Colour: [139, 0, 139], Index: 4.9 },
        { MinValue: 251, MaxValue: 1000, Colour: [139, 0, 139], Index: 5 }
    ],

    // PH
    pH: [
        { MinValue: 5, MaxValue: 5.6, Colour: [255, 0, 0], Index: 0.5 },
        { MinValue: 5.6, MaxValue: 5.9, Colour: [192, 0, 0], Index: 1 },
        { MinValue: 5.9, MaxValue: 6.2, Colour: [255, 135, 0], Index: 1.5 },
        { MinValue: 6.2, MaxValue: 6.5, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 6.5, MaxValue: 6.8, Colour: [63, 242, 0], Index: 2.5 },
        { MinValue: 6.8, MaxValue: 7.1, Colour: [37, 142, 0], Index: 3 },
        { MinValue: 7.1, MaxValue: 7.4, Colour: [72, 185, 185], Index: 3.5 },
        { MinValue: 7.4, MaxValue: 7.7, Colour: [17, 91, 239], Index: 4 },
        { MinValue: 7.7, MaxValue: 8, Colour: [234, 0, 206], Index: 4.5 },
        { MinValue: 8, MaxValue: 10, Colour: [139, 0, 139], Index: 5 }
    ],

    // Active Cabron Index
    ActiveCarbonIndex: [
        { MinValue: 1, MaxValue: 1.9, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 2, MaxValue: 2.9, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 3, MaxValue: 3.9, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 4, MaxValue: 4.9, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 5, MaxValue: 5.9, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 6, MaxValue: 6.9, Colour: [17, 91, 239], Index: 5 }
    ],

    // Available K2O
    AvailableK2O: [
        { MinValue: 0, MaxValue: 201, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 201, MaxValue: 351, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 351, MaxValue: 501, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 501, MaxValue: 701, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 701, MaxValue: 901, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 901, MaxValue: 1101, Colour: [17, 91, 239], Index: 5 }
    ],

    // Available P205
    AvailableP2O5: [
        { MinValue: 0, MaxValue: 51, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 51, MaxValue: 111, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 111, MaxValue: 131, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 131, MaxValue: 151, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 151, MaxValue: 201, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 201, MaxValue: 251, Colour: [17, 91, 239], Index: 5 }
    ],

    // Available MgO
    AvailableMgO: [
        { MinValue: 0, MaxValue: 51, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 51, MaxValue: 101, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 101, MaxValue: 201, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 201, MaxValue: 401, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 401, MaxValue: 801, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 801, MaxValue: 1601, Colour: [17, 91, 239], Index: 5 }
    ],

    // Available CaO
    AvailableCaO: [
        { MinValue: 0, MaxValue: 1001, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 1001, MaxValue: 2001, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 3001, MaxValue: 3001, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 4001, MaxValue: 5001, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 5001, MaxValue: 7001, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 7001, MaxValue: 9001, Colour: [17, 91, 239], Index: 5 }
    ],

    // Available SO3
    AvailableSO3: [
        { MinValue: 0, MaxValue: 51, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 51, MaxValue: 101, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 101, MaxValue: 131, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 131, MaxValue: 161, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 161, MaxValue: 201, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 201, MaxValue: 301, Colour: [17, 91, 239], Index: 5 }
    ],

    // Available Na
    AvailableNa: [
        { MinValue: 0, MaxValue: 21, Colour: [255, 0, 0], Index: 0 },
        { MinValue: 21, MaxValue: 51, Colour: [255, 135, 0], Index: 1 },
        { MinValue: 51, MaxValue: 101, Colour: [255, 255, 0], Index: 2 },
        { MinValue: 101, MaxValue: 151, Colour: [63, 242, 0], Index: 3 },
        { MinValue: 151, MaxValue: 201, Colour: [37, 142, 0], Index: 4 },
        { MinValue: 201, MaxValue: 301, Colour: [17, 91, 239], Index: 5 }
    ],

    // Organic matter
    OrganicMatter: [
        { MinValue: 0, MaxValue: 0.005, Colour: [160, 30, 4], Label: "0%" },
        { MinValue: 0.005, MaxValue: 0.01, Colour: [249, 61, 23], Label: "0.5%" },
        { MinValue: 0.01, MaxValue: 0.015, Colour: [251, 118, 91], Label: "1%" },
        { MinValue: 0.015, MaxValue: 0.02, Colour: [241, 166, 65], Label: "1.5%" },
        { MinValue: 0.02, MaxValue: 0.03, Colour: [211, 127, 15], Label: "2%" },
        { MinValue: 0.03, MaxValue: 0.04, Colour: [161, 97, 11], Label: "3%" },
        { MinValue: 0.04, MaxValue: 0.06, Colour: [114, 69, 8], Label: "4%" },
        { MinValue: 0.06, MaxValue: 0.08, Colour: [71, 43, 5], Label: "6%" },
        { MinValue: 0.08, MaxValue: 0.1, Colour: [43, 26, 3], Label: "8%" },
        { MinValue: 0.1, MaxValue: 1, Colour: [4, 4, 0], Label: "10%" }
    ],

    SoilTexture: [
        { MinValue: 0, MaxValue: 0.05, Colour: [255, 249, 46] },
        { MinValue: 0.05, MaxValue: 0.1, Colour: [255, 224, 39] },
        { MinValue: 0.10, MaxValue: 0.15, Colour: [255, 199, 31] },
        { MinValue: 0.15, MaxValue: 0.20, Colour: [255, 174, 24] },
        { MinValue: 0.20, MaxValue: 0.25, Colour: [255, 148, 17] },
        { MinValue: 0.25, MaxValue: 0.30, Colour: [255, 123, 10] },
        { MinValue: 0.30, MaxValue: 0.35, Colour: [255, 98, 3] },
        { MinValue: 0.35, MaxValue: 0.40, Colour: [234, 83, 1] },
        { MinValue: 0.40, MaxValue: 0.45, Colour: [200, 73, 2] },
        { MinValue: 0.45, MaxValue: 0.50, Colour: [167, 64, 3] },
        { MinValue: 0.50, MaxValue: 0.55, Colour: [134, 54, 4] },
        { MinValue: 0.55, MaxValue: 0.60, Colour: [100, 45, 5] },
        { MinValue: 0.60, MaxValue: 0.65, Colour: [67, 35, 6] },
        { MinValue: 0.65, MaxValue: 1, Colour: [34, 26, 7] }
    ]

}
